module.exports = __webpack_public_path__ + "img/slide4.8ef0490f.jpg";